import { useQuery } from "@tanstack/react-query";

import { useAppSelector } from "Hooks/useRedux";

import Api from "Api";

export default function useTravelCount() {
  const { visible, type, travelShowType } = useAppSelector((state) => state.travel);
  const { date } = useAppSelector((state) => state.filters);

  const statusQuery = () => {
    return "status=enable";
  };
  const nameQuery = () => {
    return "type=car";
  };

  const dataForPost = {
    ScenarioUniqueId: "8219b30d-fbad-4e73-b9c1-36b01326461b",
    ServiceUniqueId: "a9c670d0-ca63-499b-b766-f3ed8a07c10d",
    IncludeNonServiceBranches: false,
    Parameters: {
      "077f9fbb-7f2a-11ef-8d00-1062eb32e4ff": [],
      "077f9fcf-7f2a-11ef-8d00-1062eb32e4ff": [],
      "1271392c-bfb0-4225-9cd4-50f9ee0da0a3": [type],
      "1a5d31dd-b0ba-449a-aec8-158a3ebbdd49": date.created_after || "2020-06-03",
      "114e6c55-7b36-424d-a568-0ecd764e8309": date.created_before || "2025-06-03",
    },
    InputTables: [],
    OutputColumns: [],
  };

  //   useEffect(() => {
  //     const getCounts = async () => {

  //       console.log(res?.data?.Rows[0].sourceCount, "fgncdc");
  //       console.log(JSON.parse(`{${res?.data?.Rows[0]?.destinationCount}}`), "fgncdc2");
  //       setSurveyCounts({
  //         des: JSON.parse(`{${res?.data?.Rows[0]?.destinationCount}}`),
  //         src: JSON.parse(`{${res?.data?.Rows[0]?.sourceCount}}`),
  //       });
  //       setAllSurveyCounts({
  //         des: JSON.parse(`{${res?.data?.Rows[0]?.destinationCount}}`),
  //         src: JSON.parse(`{${res?.data?.Rows[0]?.sourceCount}}`),
  //       });
  //     };
  //     if (!applySelecteds) {
  //       getCounts();
  //     }
  //     return () => {
  //       dispatch(changeAutoApply(false));
  //       dispatch(changeApplySelected(false));
  //     };
  //   }, []);

  const { data, refetch, isLoading, isFetching } = useQuery({
    queryKey: [visible, type, travelShowType],
    queryFn: () => {
      return Api.sPost(
        "https://report2.ardban.ir:7072/https://report2.ardban.ir:8080/gateway/MSSE.DIA/api/ScenarioServiceCallApi/ShortTimeServiceExecute",
        dataForPost
      ).then((res) => {
        return res.data.Rows[0];
      });
    },
    enabled: visible && travelShowType === 2,
  });

  return { data, isLoading, refetch, isFetching };
}
